<app-breadcrumb  *ngIf="showFilter" [master]="'Należności'" [parentName]="'Salda'" [name]="'Lista'"></app-breadcrumb>
<div class="receivables-balance-list-container">
  <form *ngIf="showFilter" (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="receivables-balance-list-filters">

    <app-dict-partners
      [multiple]="false" label="Partner"
      class="receivables-balance-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="receivables-balance-list-filter"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

<!--    <app-dict-regionals-->
<!--      [multiple]="false" label="Regionalny majątek (Partner)"-->
<!--      class="receivables-balance-list-filter"-->
<!--      [(ngModel)]="initialFilters.partnerAssetsRegional" name="partnerAssetsRegional"-->
<!--    ></app-dict-regionals>-->

    <mat-form-field class="receivables-balance-list-filter"
    ><mat-label>Kwota salda od</mat-label>
      <input matInput placeholder="Kwota salda od" name="sumAmountDueFrom" [(ngModel)]="initialFilters.sumAmountDueFrom">
    </mat-form-field>

    <mat-form-field class="receivables-balance-list-filter">
      <mat-label>Kwota salda do</mat-label>
      <input matInput placeholder="Kwota salda do" name="sumAmountDueTo" [(ngModel)]="initialFilters.sumAmountDueTo">
    </mat-form-field>

    <mat-form-field class="receivables-balance-list-filter">
      <mat-label>Numer</mat-label>
      <input matInput placeholder="Numer" name="contains$recordId" [(ngModel)]="initialFilters.contains$recordId">
    </mat-form-field>

    <mat-form-field
      appearance="standard"
      class="receivables-balance-list-filter">
      <mat-label>Blokada salda</mat-label>
      <mat-select [(ngModel)]="initialFilters.active" name="active">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="0">Tak</mat-option>
        <mat-option [value]="1">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'contract_owner'"
      [label]="'Strona umowy'" class="receivables-balance-list-filter"
      [(ngModel)]="initialFilters.owner" name="owner"
    ></app-dict>

<!--    <mat-form-field class="receivables-balance-list-filter" *ngIf="structure!=='ofwca'"-->
<!--    ><mat-label>Kwota oczekująca na zaksięgowanie od</mat-label>-->
<!--      <input matInput placeholder="Kwota oczekująca na zaksięgowanie  od" name="statementSumFrom" [(ngModel)]="initialFilters.statementSumFrom">-->
<!--    </mat-form-field>-->

<!--    <mat-form-field class="receivables-balance-list-filter" *ngIf="structure!=='ofwca'">-->
<!--      <mat-label>Kwota oczekująca na zaksięgowanie do</mat-label>-->
<!--      <input matInput placeholder="Kwota oczekująca na zaksięgowanie  do" name="statementSumTo" [(ngModel)]="initialFilters.statementSumTo">-->
<!--    </mat-form-field>-->

  </form>

  <div *ngIf="showFilter" class="receivables-balance-list-buttons">
    <button *ngIf="(userPermissions | async).receivables.read_report" [disabled]="!(userPermissions | async).receivables.read_report" mat-raised-button class="report-button" (click)="downloadReport()">Pobierz raport</button>
    <button (click)="filter()"  mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()"  mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div *ngIf="showFilter" class="receivables-balance-add-button">
    <button *ngIf="(userPermissions | async).receivables.write"  (click)="add()"  mat-raised-button color="accent"><mat-icon>add</mat-icon> <span>Dodaj saldo</span></button>
<!--    <button   [disabled]="restartDialogOpen || !(userPermissions | async)?.receivables.admin_root" mat-raised-button color="primary"-->
<!--              class="add-button" (click)="restartReceivablesBalance()"><mat-icon>restart_alt</mat-icon> Odśwież salda</button>-->
  </div>

  <table mat-table [dataSource]="rows" matSort (matSortChange)="sortChanged($event)">

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef > Imię i nazwisko OFWCA
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.ofwcaId" class="default-link" [routerLink]="['/ofwca/szczegoly', element?.ofwcaId]">
          {{element.ofwcaFirstName}}  {{element.ofwcaLastName}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="pesel">
      <th mat-header-cell *matHeaderCellDef > PESEL OFWCA
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.ofwcaPesel" class="default-link" [routerLink]="['/ofwca/szczegoly', element?.ofwcaId]">
          {{element.ofwcaPesel}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="nip">
      <th mat-header-cell *matHeaderCellDef> NIP </th>
      <td mat-cell *matCellDef="let element">
        {{element.partner?.nip}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partner" *ngIf="(userPermissions | async).receivables.read">
      <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.partner !== null" class="default-link" [routerLink]="['/naleznosci/salda/szczegoly', element.uuid]">
          <mat-chip-list >
            <mat-chip class="statusChange-button-container"  selected  matTooltip="Partner">P</mat-chip> {{element.partner?.shortName}}
          </mat-chip-list>
<!--        {{element.partner?.shortName}}-->
        </a>
        <a *ngIf="element.ofwca !== null " class="default-link" [routerLink]="['/naleznosci/salda/szczegoly', element.uuid]">
          <mat-chip-list >
            <mat-chip class="statusChange-button-container" color="warn" selected  matTooltip="OFWCA">O</mat-chip>           {{element.ofwca?.firstName}} {{element.ofwca?.lastName}}
          </mat-chip-list>
<!--          {{element.ofwca?.firstName}} {{element.ofwca?.lastName}}-->
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="partner" *ngIf="!(userPermissions | async).receivables.read ">
      <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
      <td mat-cell *matCellDef="let element">

          <mat-chip-list *ngIf="element.partner !== null" >
            <mat-chip class="statusChange-button-container"  selected  matTooltip="Partner">P</mat-chip> {{element.partner?.shortName}}
          </mat-chip-list>
          <!--        {{element.partner?.shortName}}-->

          <mat-chip-list *ngIf="element.ofwca !== null " >
            <mat-chip class="statusChange-button-container" color="warn" selected  matTooltip="OFWCA">O</mat-chip>           {{element.ofwca?.firstName}} {{element.ofwca?.lastName}}
          </mat-chip-list>
          <!--          {{element.ofwca?.firstName}} {{element.ofwca?.lastName}}-->
      </td>
    </ng-container>

    <ng-container matColumnDef="regional">
      <th mat-header-cell *matHeaderCellDef> Regionalny </th>
      <td mat-cell *matCellDef="let element">
        <p *ngIf="element.partner  !== null" >
          {{element.partner?.assetsRegionalFullName}}
        </p>
        <p *ngIf="element.ofwca  !== null">
          {{element.ofwca.assetsRegional?.firstName}} {{element.ofwca.assetsRegional?.lastName}}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="sum">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header="sum"> Kwota salda </th>
      <td mat-cell *matCellDef="let element">
        {{(element?.sumDeposits !== null ? element.sumDeposits - element.sumPolicy : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="namber">
      <th mat-header-cell *matHeaderCellDef> Numer </th>
      <td mat-cell *matCellDef="let element">
        {{element.recordId}}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef> Blokada salda </th>
      <td mat-cell *matCellDef="let element">
        {{element.active ? 'Nie' : 'Tak' }}
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator  [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
